(() => {
  const FAVORITES_KEY = 'dk-favorites-v1';
  const RECENT_KEY = 'dk-recent-v1';
  const read = (key) => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; } };
  const write = (key, value) => localStorage.setItem(key, JSON.stringify(value));
  const favorites = () => read(FAVORITES_KEY);
  const escapeText = (value) => String(value || '');

  function updateFavorites() {
    const saved = favorites();
    document.querySelectorAll('[data-dk-favorite]').forEach((button) => {
      const active = saved.some((item) => item.handle === button.dataset.handle);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
    document.querySelectorAll('[data-dk-favorites-count]').forEach((node) => {
      node.textContent = saved.length;
      node.hidden = saved.length === 0;
    });
    const list = document.querySelector('[data-dk-favorites-list]');
    if (!list) return;
    list.replaceChildren();
    if (!saved.length) {
      const empty = document.createElement('p'); empty.className = 'dk-favorites__empty'; empty.textContent = 'Henüz favori ürün eklenmedi.'; list.append(empty); return;
    }
    saved.forEach((item) => {
      const li = document.createElement('li'); const link = document.createElement('a'); link.href = item.url;
      const img = document.createElement('img'); img.src = item.image; img.alt = '';
      const span = document.createElement('span'); span.textContent = item.title;
      link.append(img, span); li.append(link); list.append(li);
    });
  }

  function toast(message, href) {
    const node = document.querySelector('[data-dk-toast]'); if (!node) return;
    node.replaceChildren(document.createTextNode(message));
    if (href) {
      const link = document.createElement('a');
      link.href = href;
      link.textContent = 'Sepete git';
      node.append(document.createTextNode(' · '), link);
    }
    node.hidden = false; clearTimeout(window.__dkToastTimer);
    window.__dkToastTimer = setTimeout(() => { node.hidden = true; }, 4200);
  }

  document.addEventListener('click', (event) => {
    const favorite = event.target.closest('[data-dk-favorite]');
    if (favorite) {
      event.preventDefault(); event.stopPropagation();
      const saved = favorites(); const index = saved.findIndex((item) => item.handle === favorite.dataset.handle);
      if (index >= 0) saved.splice(index, 1); else saved.unshift({handle:favorite.dataset.handle,title:favorite.dataset.title,url:favorite.dataset.url,image:favorite.dataset.image});
      write(FAVORITES_KEY, saved.slice(0, 30)); updateFavorites(); toast(index >= 0 ? 'Favorilerden çıkarıldı.' : 'Favorilere eklendi.'); return;
    }
    const open = event.target.closest('[data-dk-favorites-open]');
    if (open) { event.preventDefault(); updateFavorites(); document.querySelector('[data-dk-favorites]')?.showModal(); return; }
    const close = event.target.closest('[data-dk-favorites-close]');
    if (close) document.querySelector('[data-dk-favorites]')?.close();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-dk-add-form]'); if (!form) return;
    event.preventDefault(); const submit = form.querySelector('[type="submit"]'); if (submit?.disabled) return;
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method:'POST', headers:{Accept:'application/json'}, body:new FormData(form) });
      if (!response.ok) throw new Error('add failed');
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((item) => item.json());
      document.querySelectorAll('[data-dk-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; });
      toast('Ürün sepete eklendi.', (window.Shopify.routes.root || '/') + 'cart');
    } catch { toast('Ürün sepete eklenemedi. Lütfen tekrar deneyin.'); }
    finally { if (submit) submit.disabled = false; }
  });

  document.addEventListener('dk:content', updateFavorites);
  const current = document.querySelector('[data-dk-current-product]');
  if (current) {
    const recent = read(RECENT_KEY).filter((item) => item.handle !== current.dataset.handle);
    recent.unshift({handle:current.dataset.handle,title:current.dataset.title,url:current.dataset.url,image:current.dataset.image,price:Number(current.dataset.price),currency:current.dataset.currency});
    write(RECENT_KEY, recent.slice(0, 8));
  }
  const recentGrid = document.querySelector('[data-dk-recent]');
  if (recentGrid) {
    const recent = read(RECENT_KEY).slice(0, 4); const empty = recentGrid.parentElement.querySelector('[data-dk-recent-empty]');
    if (recent.length) { if (empty) empty.hidden = true; }
    recent.forEach((item) => {
      const article = document.createElement('article'); article.className = 'dk-card';
      const link = document.createElement('a'); link.className = 'dk-card__link'; link.href = item.url;
      const media = document.createElement('div'); media.className = 'dk-card__media'; const img = document.createElement('img'); img.src = item.image; img.alt = item.title; media.append(img);
      const body = document.createElement('div'); body.className = 'dk-card__body'; const code = document.createElement('p'); code.className = 'dk-code'; code.textContent = 'Son görüntülenen'; const title = document.createElement('h3'); title.textContent = item.title; const price = document.createElement('p'); price.className = 'dk-card__price'; price.textContent = new Intl.NumberFormat('tr-TR',{style:'currency',currency:item.currency||'TRY'}).format(item.price/100);
      body.append(code,title,price); link.append(media,body); article.append(link); recentGrid.append(article);
    });
  }

  const lightbox = document.querySelector('[data-dk-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-dk-lightbox-image]');
  const lightboxStage = lightbox?.querySelector('[data-dk-lightbox-stage]');
  const lightboxCounter = lightbox?.querySelector('[data-dk-lightbox-counter]');
  const lightboxPrev = lightbox?.querySelector('[data-dk-lightbox-prev]');
  const lightboxNext = lightbox?.querySelector('[data-dk-lightbox-next]');
  const zoomItems = [...document.querySelectorAll('[data-dk-product-zoom]')];
  const lightboxThumbs = [...(lightbox?.querySelectorAll('[data-dk-lightbox-thumb]') || [])];
  let lightboxIndex = 0;
  let swipeStartX = null;
  const renderLightbox = (index, direction = 1) => {
    if (!lightboxImage || !zoomItems.length) return;
    lightboxIndex = (index + zoomItems.length) % zoomItems.length;
    const button = zoomItems[lightboxIndex];
    lightboxStage?.classList.remove('is-from-prev', 'is-from-next');
    lightboxStage?.classList.add(direction < 0 ? 'is-from-prev' : 'is-from-next', 'is-changing');
    lightboxImage.removeAttribute('srcset');
    lightboxImage.removeAttribute('sizes');
    lightboxImage.src = button.dataset.dkZoomSrc || '';
    lightboxImage.alt = button.dataset.dkZoomAlt || '';
    if (lightboxCounter) lightboxCounter.textContent = `${lightboxIndex + 1} / ${zoomItems.length}`;
    lightboxThumbs.forEach((thumb, thumbIndex) => {
      thumb.setAttribute('aria-current', thumbIndex === lightboxIndex ? 'true' : 'false');
      if (thumbIndex === lightboxIndex) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
    const neighbor = zoomItems[(lightboxIndex + direction + zoomItems.length) % zoomItems.length];
    if (neighbor?.dataset.dkZoomSrc) new Image().src = neighbor.dataset.dkZoomSrc;
  };
  lightboxImage?.addEventListener('load', () => lightboxStage?.classList.remove('is-changing'));
  zoomItems.forEach((button, index) => button.addEventListener('click', () => {
    if (!lightbox?.open) lightbox?.showModal();
    renderLightbox(index);
  }));
  const moveLightbox = (step) => renderLightbox(lightboxIndex + step, step);
  lightboxPrev?.addEventListener('click', () => moveLightbox(-1));
  lightboxNext?.addEventListener('click', () => moveLightbox(1));
  lightboxThumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    const targetIndex = Number(thumb.dataset.index || 0);
    renderLightbox(targetIndex, targetIndex < lightboxIndex ? -1 : 1);
  }));
  if (zoomItems.length <= 1) {
    if (lightboxPrev) lightboxPrev.hidden = true;
    if (lightboxNext) lightboxNext.hidden = true;
    lightbox?.querySelector('[data-dk-lightbox-thumbs]')?.setAttribute('hidden', '');
  }
  lightboxStage?.addEventListener('pointerdown', (event) => { swipeStartX = event.clientX; });
  lightboxStage?.addEventListener('pointerup', (event) => {
    if (swipeStartX === null) return;
    const distance = event.clientX - swipeStartX;
    swipeStartX = null;
    if (Math.abs(distance) > 48) moveLightbox(distance > 0 ? -1 : 1);
  });
  lightbox?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); moveLightbox(-1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); moveLightbox(1); }
  });
  document.querySelector('[data-dk-product-zoom-close]')?.addEventListener('click', () => lightbox?.close());
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });

  document.querySelectorAll('[data-dk-color-variant]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-dk-color-variant]').forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      const input = document.querySelector('[data-dk-variant-id]');
      if (input) input.value = button.dataset.variantId;
      const sku = document.querySelector('[data-dk-variant-sku]');
      if (sku) sku.textContent = button.dataset.sku || '';
      document.querySelectorAll('[data-dk-media-color]').forEach((media) => {
        media.hidden = Boolean(media.dataset.dkMediaColor) && media.dataset.dkMediaColor !== button.dataset.color;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', button.dataset.variantId);
      window.history.replaceState({}, '', url);
    });
  });
  const initialColor = document.querySelector('[data-dk-color-variant][aria-pressed="true"]');
  if (initialColor) initialColor.click();

  const variantSelect = document.querySelector('[data-dk-variant-select]');
  if (variantSelect) {
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style:'currency', currency:window.Shopify?.currency?.active || 'TRY' }).format(Number(cents || 0) / 100);
    const updateVariant = () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      const input = document.querySelector('[data-dk-variant-id]');
      const submit = document.querySelector('[data-dk-variant-submit]');
      const price = document.querySelector('[data-dk-variant-price]');
      const compare = document.querySelector('[data-dk-variant-compare]');
      const sku = document.querySelector('[data-dk-variant-sku]');
      const stock = document.querySelector('[data-dk-variant-stock]');
      if (input) input.value = option.value;
      if (submit) submit.disabled = !available;
      if (price) price.textContent = money(option.dataset.price);
      const compareValue = Number(option.dataset.compare || 0);
      if (compare) {
        compare.hidden = compareValue <= Number(option.dataset.price || 0);
        const strike = compare.querySelector('s'); if (strike) strike.textContent = compareValue ? money(compareValue) : '';
      }
      if (sku) sku.textContent = option.dataset.sku || '';
      if (stock) stock.textContent = available ? 'Siparişe açık' : 'Stokta yok; stok ve üretim bilgisini sorabilirsiniz';
      const media = option.dataset.mediaId ? document.querySelector(`[data-dk-media-id="${CSS.escape(option.dataset.mediaId)}"]`) : null;
      media?.scrollIntoView({ behavior:'smooth', block:'nearest' });
      const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
    };
    variantSelect.addEventListener('change', updateVariant);
  }

  const backToTop = document.querySelector('[data-dk-back-to-top]');
  if (backToTop) {
    const page = document.querySelector('.page-wrapper');
    const position = () => Math.max(window.scrollY, page?.scrollTop || 0);
    const update = () => { backToTop.hidden = position() < 700; };
    window.addEventListener('scroll', update, { passive: true });
    page?.addEventListener('scroll', update, { passive: true });
    backToTop.addEventListener('click', () => {
      if (page && page.scrollTop > 0) page.scrollTo({ top: 0, behavior: 'smooth' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    update();
  }
  updateFavorites();
})();
